// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign20: FC<Campaign20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M15 10.75v-1.5h3v1.5h-3Zm.854 5.75-2.458-1.708.875-1.23 2.458 1.709-.875 1.229ZM14.25 6.437l-.854-1.229L15.854 3.5l.854 1.23-2.458 1.707ZM4 16v-4h-.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 2 10.5v-1c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h2.896L11 5.25v9.5L6.52 12H6v4H4Zm5.5-3.938V7.896L6.812 9.5H3.5v1h3.458L9.5 12.063Zm2.5.376V7.561c.32.306.566.674.74 1.105a3.534 3.534 0 0 1 0 2.666c-.174.43-.42.799-.74 1.104Z" />
        </svg>
    );
};

export default Campaign20;
